import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type PaymentHistoryInvoice } from '../modal/invoice';

interface GetPaymentHistoryParams {
  startDate: string;
  endDate: string;
}

export const getPaymentHistory = async (params: GetPaymentHistoryParams) => {
  const response = await baseAPI.get<Array<PaymentHistoryInvoice>>(
    `subscription-invoices/payment-history`,
    {
      params: {
        ...params,
      },
    },
  );
  return response.data;
};

export const useGetPaymentHistory = (params: GetPaymentHistoryParams) => {
  return useQuery({
    queryKey: [KEYS.PAYMENT_HISTORY, params.startDate, params.endDate],
    queryFn: () => getPaymentHistory(params),
    // Keep prior history rows visible while Retry invalidates (ENR-2160 flicker).
    placeholderData: keepPreviousData,
  });
};
